<script>
export default {
  name: "TemperatureCorrectionForm",
  props: {
    enabled: { type: Boolean, default: () => false },
    a: { type: Number, default: () => 0 },
    b: { type: Number, default: () => 0 },
    c: { type: Number, default: () => 0 },
    d: { type: Number, default: () => 0 },
  },
};
</script>

<template>
  <v-form>
    <v-container>
      <v-row>
        <span class="subtitle-1">零点移動の温度補正</span>
        <v-col cols="12" class="my-0 py-0">
          <v-checkbox
            label="計算時に以下の補正値を使用する"
            class="temp-corr__checkbox"
            :input-value="enabled"
            @change="$emit('update', { enabled: $event })"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-text-field
            label="a"
            class="temp-corr__a"
            :value="a"
            @input="$emit('update', { a: +$event })"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-text-field
            label="b"
            class="temp-corr__b"
            :value="b"
            @input="$emit('update', { b: +$event })"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-text-field
            label="c"
            class="temp-corr__c"
            :value="c"
            @input="$emit('update', { c: +$event })"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-text-field
            label="d"
            class="temp-corr__d"
            :value="d"
            @input="$emit('update', { d: +$event })"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
